import React from 'react'
import PropTypes from 'prop-types'

function Image360({
  image,
  className,
  ...otherProps
}) {
  return (
    <div className={`mz-image-360 ${className}`} data-src={image} {...otherProps}>
      <div className="mz-image-360-inner">
        <div className="mz-image-360-content">
          {/* panorama view is appended here by pannellum.js library from Core */}
        </div>
      </div>
    </div>
  )
}

Image360.propTypes = {
  image: PropTypes.string.isRequired,
  className: PropTypes.string,
}

Image360.defaultProps = {
  image: '',
  className: ''
}

export default Image360